import { Box, Grid, GridItem, SystemStyleObject } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../../../../common/styles';
import { DialogTrainInfoType } from '../../../../context/TransitsContextProvider';
import {
  LanguageContext,
  LanguageType
} from '../../../../context/LanguageContextProvider';
import { SvgLowFloorIcon } from '../../../atoms/svg/LowFloorIcon';

const destinationStyle: { [key in LanguageType]: SystemStyleObject } = {
  ja: {
    gridTemplateAreas: `
    '... ... ... ... ...'
    '... ename ... ... ...'
    '... ... ... ... ...'
    '... name ... iki ...'
    '... ... ... ... ...'
    `,
    gridTemplateRows: '0% 45% 0% 45% 10%',
    gridTemplateColumns: '1fr auto 7px 36px 1fr'
  },
  en: {
    gridTemplateAreas: `
    '... ... ... ... ...'
    '... ... ... ename ...'
    '... ... ... ... ...'
    '... iki ... name ...'
    '... ... ... ... ...'
    `,
    gridTemplateRows: '0% 45% 0% 45% 10%',
    gridTemplateColumns: '1fr 35px 7px auto 2fr'
  }
};

// 系統番号表示欄の色、表示文字列、文字サイズを返す
const getKeitouInfo = (fontColorNo: number) => {
  let bgColor = '';
  let fontColor = '';
  let ja = '';
  let en = '';
  let fontSize = { ja: '36px', en: '36px' };
  switch (fontColorNo) {
    case 1:
      bgColor = '#00b0f0';
      fontColor = 'white';
      ja = '1';
      en = '1';
      break;
    case 3:
      bgColor = 'red';
      fontColor = 'white';
      ja = '3';
      en = '3';
      break;
    case 4:
      bgColor = '#ff0';
      fontColor = 'black';
      ja = '4';
      en = '4';
      break;
    case 5:
      bgColor = '#00b200';
      fontColor = 'white';
      ja = '5';
      en = '5';
      break;

    default:
      bgColor = 'grey';
      fontColor = 'white';
      ja = '他';
      en = 'OTH';
      fontSize = { ja: '28px', en: '20px' };
      break;
  }
  return { fontColor, bgColor, ja, en, fontSize };
};

type Props = {
  trainInfo: DialogTrainInfoType;
};

export const TrainInfo: React.FC<Props> = (props) => {
  const { trainInfo } = props;
  const { language } = useContext(LanguageContext);

  return (
    <Grid
      w='100%'
      h='100%'
      gridTemplateAreas={`'... keitouNo destination trainNo ...'`}
      gridTemplateColumns='5px 60px 1fr 50px 5px'
    >
      {/* 系統番号 */}
      <GridItem gridArea='keitouNo' sx={{ ...commonStyle.center }}>
        <Box
          w='50px'
          h='50px'
          bgColor={getKeitouInfo(trainInfo.course).bgColor}
          color={getKeitouInfo(trainInfo.course).fontColor}
          fontSize={getKeitouInfo(trainInfo.course).fontSize[language]}
          fontWeight='bold'
          sx={{
            ...commonStyle.center,
            borderRadius: '10px',
            border: 'solid 2px black'
          }}
        >
          {getKeitouInfo(trainInfo.course)[language]}
        </Box>
      </GridItem>

      {/* 行先 */}
      <GridItem gridArea='destination'>
        <Grid w='100%' h='100%' sx={{ ...destinationStyle[language] }}>
          <GridItem
            gridArea='ename'
            fontSize={
              trainInfo.destination_name_en.length > 15
                ? 'clamp(0.625rem, -0.102rem + 3.64vw, 0.75rem)'
                : 'clamp(0.813rem, -0.278rem + 5.45vw, 1rem)'
            }
            fontWeight='bold'
            whiteSpace='nowrap'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end'
            }}
          >
            {trainInfo.destination_name_en}
          </GridItem>

          <GridItem
            gridArea='name'
            whiteSpace='nowrap'
            fontSize={
              trainInfo.destination_name.length > 3
                ? 'clamp(0.938rem, -0.153rem + 5.45vw, 1.125rem)'
                : 'clamp(2rem, 0.545rem + 7.27vw, 2.25rem)'
            }
            fontWeight='bold'
            sx={{ ...commonStyle.center }}
          >
            {trainInfo.destination_name}
          </GridItem>

          <GridItem
            gridArea='iki'
            fontSize='18px'
            fontWeight='bold'
            paddingRight={language === 'en' ? '5px' : undefined}
            paddingBottom={language === 'en' ? '5px' : undefined}
            sx={{
              ...commonStyle.center,
              alignItems: language === 'en' ? 'flex-end' : 'flex-end',
              justifyContent: language === 'en' ? 'flex-end' : undefined
            }}
          >
            {language === 'en' ? 'For' : '行き'}
          </GridItem>
        </Grid>
      </GridItem>

      {/* 車号 */}
      <GridItem
        gridArea='trainNo'
        fontSize='14px'
        fontWeight='bold'
        sx={{ ...commonStyle.center, flexFlow: 'column' }}
      >
        <Box w='100%' h='20px' sx={{ ...commonStyle.center }}>
          {`${trainInfo.train_no}`}
        </Box>

        {trainInfo.low_floor_flag && (
          <Box w='35px' h='35px' marginTop='2px' sx={{ ...commonStyle.center }}>
            <svg width='100%' height='100%'>
              <g transform={`scale(0.229)`}>
                <SvgLowFloorIcon></SvgLowFloorIcon>
              </g>
            </svg>
          </Box>
        )}
      </GridItem>
    </Grid>
  );
};
